'use client';

import { useContext } from 'react';

import { RequestContext } from '@Contexts/Request';

export default function useRequest() {
  const request = useContext(RequestContext);

  return request;
}
